import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => {
    return <>We are going to find similar seats for all games in your pack.</>;
  },
};

function PredatorsLink() {
  return (
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href={"https://am.ticketmaster.com/predators/"}
    >
      Account Manager
    </Link>
  );
}

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      " Click Continue and connect your Nashville Predators account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <PredatorsLink /> within 24 hours of
        redemption. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Nashville Predators Holiday Pack work?",
    description: (
      <>
        The Nashville Predators Holiday Pack presented by the Loveless Cafe
        allows fans to select 2 upper level or lower level seats to the above
        games. This also includes a $10 Gnash Cash per seat, a holiday ornament
        and a $25 gift card to the Loveless Cafe. Simply log into your Nashville
        Predators <PredatorsLink /> and select games.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your Nashville Predators{" "}
        <PredatorsLink />.
      </>
    ),
  },
];
